import React, { useState, useEffect, useRef } from "react";
import { alpha } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";

import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  Menu,
  Chip,
  Stack,
  Tooltip,
  CircularProgress,
  IconButton,
} from "@mui/material";
import Swal from "sweetalert2";
import Pagination from "@mui/material/Pagination";
import axios from "axios";
import Styles from "../../../styles/vendorDashboard.module.css";

import styles from "../../../styles/adminPortal.module.css";
import FileUploadIcon from "../../../shared/assets/icons/FileUploadIcon.jsx";
import FileDownloadIcon from "../../../shared/assets/icons/FileDownload.jsx";
import DownloadIcon from "../../../shared/assets/icons/Download.jsx";
import { downloadExcelForInputLocations } from "../RFP/downloadExcelSheetForInputLocations.jsx";

const getHeadCells = () => [
  { id: "gstin", label: "GSTIN", width: 100 },
  { id: "legalName", label: "Legal Name", width: 200 },
  { id: "tradeName", label: "Trade Name", width: 160 },
  { id: "status", label: "Status", width: 150 },
  { id: "constitution", label: "Constitution", width: 150 },
  { id: "registrationDate", label: "Registration Date", width: 150 },
  { id: "address", label: "Address", width: 220 },
  { id: "phone", label: "Phone", width: 80 },
  { id: "error", label: "Error", width: 100 },
];

function EnhancedTableHead(props) {
  const [headCells, setHeadCells] = useState(getHeadCells);

  //   useEffect(() => {
  //     const role = localStorage.getItem("role");
  //     setHeadCells(getHeadCells(role));
  //   }, []);
  return (
    <TableHead className={styles.tableHead}>
      <TableRow>
        {headCells.map((headCell, index) => (
          <TableCell
            key={index}
            className={styles.tableCell}
            sx={{
              minWidth: headCell.width,
            }}
          >
            <span className={styles.headCellHeading}> {headCell.label} </span>

            <div className={styles.topBorderDiv}>
              <input
                type="text"
                className={styles.searchInput}
                placeholder={`Search`}
                onChange={(e) => props.handleSearchChangeHead(e, headCell.id)}
                value={props.searchInputs?.[headCell.id] || ""} // Access search inputs from props
              />
              {/* )} */}
            </div>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

function EnhancedTableToolbar(props) {
  const userRole = localStorage.getItem("role");
  const { numSelected } = props;
  const handleOpen = (e) => {
    props.setSelectedRFP(null);
    props.setRfpGenerate(true);
    props.setOperation("");
  };
  return (
    <>
      <div className=" border-b flex justify-between items-center h-14 pt-2">
        <div className="font-bold text-md text-gray-600">
          Upload Stores For Verification
        </div>
        <div className="flex gap-2">
          <div>
            <Tooltip title="Download Excel file for locations" placement="top">
              <IconButton onClick={() => downloadExcelForInputLocations()}>
                <DownloadIcon />
              </IconButton>
            </Tooltip>

            <>
              <input
                type="file"
                ref={props.fileInputRef}
                onChange={props.handleFileChange}
                style={{ display: "none" }}
                accept=".xlsx,.xls"
              />
              <Tooltip
                title="Upload GSTIN for Store Verification"
                placement="top"
              >
                <IconButton
                  onClick={() => props.fileInputRef.current.click()} // open file modal
                  disabled={props.loading}
                >
                  {props.loading ? (
                    <CircularProgress size={20} />
                  ) : (
                    <FileUploadIcon />
                  )}
                </IconButton>
              </Tooltip>
            </>
          </div>
          {props.excelFileData && (
            <div>
              <Tooltip title="Download Verified Excel">
                <IconButton onClick={props.handleDownloadExcel}>
                  <FileDownloadIcon />
                </IconButton>
              </Tooltip>
            </div>
          )}
        </div>
      </div>
    </>
  );
}

const VerifyStoreLocations = () => {
  const [headCells, setHeadCells] = useState(getHeadCells);
  const [locationsListLoading, setLocationsListLoading] = useState(false);
  const [locationsList, setLocationsList] = useState([]);
  const [filteredLocationsList, setFilteredLocationsList] = useState([]);
  const [searchInputs, setSearchInputs] = useState({});
  const [pageSize, setPageSize] = useState(100);
  const pageSizeOptions = [5, 10, 20, 50, 100];
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const serverURL = process.env.REACT_APP_URL;
  const fileInputRef = React.useRef(null);
  const token = localStorage.getItem("token");
  const [excelFileData, setExcelFileData] = useState(null);
  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      handleUpload(selectedFile); // auto-upload after selection
      e.target.value = null; // reset immediately
    }
  };
  const handleUpload = async (selectedFile) => {
    if (!selectedFile) return alert("Please upload an Excel file");

    setLocationsListLoading(true);
    const formData = new FormData();
    formData.append("file", selectedFile);

    try {
      const response = await axios.post(
        `${serverURL}/upload-template/verifyStoresLocations`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      // ✅ 1. Update table with JSON data
      const data = response.data.data || [];
      setLocationsList(data);
      setFilteredLocationsList(data);

      // ✅ 2. Convert base64 Excel to downloadable file
      const base64Excel = response.data.excelFile;
      setExcelFileData(base64Excel);
    } catch (err) {
      console.error(err);
      alert("Upload failed");
    } finally {
      setLocationsListLoading(false);
    }
  };

  const handleDownloadExcel = () => {
    if (!excelFileData) {
      alert("No file available to download");
      return;
    }

    try {
      // Convert base64 Excel to downloadable file
      const byteCharacters = atob(excelFileData);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.setAttribute("download", "verified-gstin.xlsx");
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.error("Download failed:", error);
      alert("Failed to download file");
    }
  };

  const handleSearchChangeHead = (e, key) => {
    const value = e.target.value.toLowerCase();
    const updatedInputs = { ...searchInputs, [key]: value };
    setSearchInputs(updatedInputs);

    // Define mapping once
    const keyToFieldMap = {
      gstin: "GSTIN",
      legalName: "LegalName",
      tradeName: "TradeName",
      status: "Status",
      constitution: "Constitution",
      registrationDate: "RegistrationDate",
      address: "Address",
      phone: "Phone",
      error: "error",
    };

    const filtered = locationsList.filter((location) => {
      return Object.entries(updatedInputs).every(([filterKey, filterValue]) => {
        if (!filterValue) return true;

        const fieldName = keyToFieldMap[filterKey];
        const locationValue = location?.[fieldName] || "";

        return (
          typeof locationValue === "string" &&
          locationValue.toLowerCase().includes(filterValue)
        );
      });
    });

    setFilteredLocationsList(filtered);
  };

  return (
    <div className={styles.tableGround}>
      <Box>
        {!locationsListLoading ? (
          <>
            <Paper
              sx={{ width: "100%", boxShadow: "none" }}
              className={styles.tableGap}
            >
              <EnhancedTableToolbar
                handleFileChange={handleFileChange}
                fileInputRef={fileInputRef}
                // OnModalOpen={(value) => handleModalOpen(value)}
                // onSearchChange={(value) => handleSearchChangeHead(value)}
                loading={locationsListLoading}
                // setRfpGenerate={setRfpGenerate}
                // setSelectedRFP={setSelectedRFP}
                // setOperation={setOperation}
                handleDownloadExcel={handleDownloadExcel}
                excelFileData={excelFileData}
              />

              <>
                <TableContainer
                  className={`${styles.tableContainer} ${Styles["custom-scrollbar"]}`}
                >
                  <Table stickyHeader className="rounded-lg ">
                    <EnhancedTableHead
                      //   userListData={getRfpList}
                      //   setSearchInputs={setSearchInputs} // Function to update search inputs
                      //   handleSearchChangeHead={handleSearchChangeHead}
                      //   searchInputs={searchInputs}
                      handleSearchChangeHead={handleSearchChangeHead}
                      searchInputs={searchInputs}
                    />

                    {filteredLocationsList?.length > 0 ? (
                      <TableBody>
                        {filteredLocationsList.map((v, index) => {
                          return (
                            <TableRow
                              hover
                              className={styles.tableRowHead}
                              tabIndex={-1}
                              key={index}
                            >
                              <TableCell
                                sx={{ maxWidth: "200px" }}
                                className={styles.tableRow}
                              >
                                <Tooltip title={v?.gstin} arrow placement="top">
                                  <span className={styles.truncateText}>
                                    {v?.GSTIN || ""}
                                  </span>
                                </Tooltip>
                              </TableCell>
                              <TableCell
                                sx={{ maxWidth: "200px" }}
                                className={styles.tableRow}
                              >
                                <Tooltip
                                  title={v?.LegalName || "Not Available"}
                                  arrow
                                  placement="top"
                                >
                                  <span className={styles.truncateText}>
                                    {v?.LegalName || "Not Available"}
                                  </span>
                                </Tooltip>
                              </TableCell>
                              <TableCell
                                sx={{ maxWidth: "160px" }}
                                className={styles.tableRow}
                              >
                                <Tooltip
                                  title={v?.TradeName || ""}
                                  arrow
                                  placement="top"
                                >
                                  <span className={styles.truncateText}>
                                    {v?.TradeName || "Not Available"}
                                  </span>
                                </Tooltip>
                              </TableCell>
                              <TableCell className={styles.tableRow}>
                                <span className={styles.truncateText}>
                                  {v?.Status || "Not Available"}
                                </span>
                              </TableCell>
                              <TableCell className={styles.tableRow}>
                                <span className={styles.truncateText}>
                                  {v?.Constitution}
                                </span>
                              </TableCell>
                              <TableCell className={styles.tableRow}>
                                <span className={styles.truncateText}>
                                  {v?.RegistrationDate}
                                </span>
                              </TableCell>
                              <Tooltip
                                title={v?.Address || ""}
                                arrow
                                placement="top"
                              >
                                <TableCell className={styles.tableRow}>
                                  <span className={styles.truncateText}>
                                    {v?.Address}
                                  </span>
                                </TableCell>
                              </Tooltip>

                              <TableCell className={styles.tableRow}>
                                <span className={styles.truncateText}>
                                  {v?.Phone}
                                </span>
                              </TableCell>
                              <TableCell className={styles.tableRow}>
                                <span className={styles.truncateText}>
                                  {v?.error}
                                </span>
                              </TableCell>
                            </TableRow>
                          );
                        })}
                      </TableBody>
                    ) : (
                      <TableRow>
                        <TableCell
                          colSpan={headCells?.length}
                          sx={{ borderBottom: "none" }}
                        >
                          <div className="flex justify-center items-center h-64">
                            No Data Found.
                          </div>
                        </TableCell>
                      </TableRow>
                    )}
                  </Table>
                </TableContainer>
                <hr
                  className="mt-2 bg-gray-200 "
                  style={{ border: "0.5px solid var(--light-grey-color)" }}
                />

                <div className="flex items-center justify-between ">
                  <FormControl
                    variant="standard"
                    size="small"
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      gap: 1,
                      "& .MuiInputBase-root:before": { borderBottom: "none" },
                      "& .MuiInputBase-root:after": { borderBottom: "none" },
                      "& .MuiInputBase-root": { marginTop: 1 }, // 👈 override here
                    }}
                  >
                    <InputLabel
                      id="page-size-label"
                      sx={{
                        position: "static",
                        transform: "none",
                        fontSize: "14px",
                        marginRight: "8px",
                        marginTop: "2px",
                      }}
                    >
                      Rows
                    </InputLabel>

                    <Select
                      labelId="page-size-label"
                      value={pageSize}
                      //   onChange={handlePageSizeChange}
                      variant="standard"
                      disableUnderline
                    >
                      {pageSizeOptions?.map((size) => (
                        <MenuItem key={size} value={size}>
                          {size}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>

                  {/* <GlobalSnackbar
                    snackbar={snackbar}
                    handleClose={handleSnackbarClose}
                  /> */}

                  <Pagination
                    className="p-2 flex justify-center"
                    count={totalPages}
                    page={page}
                    // onChange={handlePageChange}
                    sx={{
                      "& .MuiPaginationItem-root.Mui-selected": {
                        backgroundColor: "#418cff", // Blue background for selected
                        color: "#fff", // White text for selected
                      },
                      "& .MuiPaginationItem-root.Mui-selected:hover": {
                        backgroundColor: "#3366cc", // Darker blue on hover
                      },
                      "& .MuiPaginationItem-root": {
                        "&:hover": {
                          backgroundColor: "#ddd", // Light gray for hovered items
                        },
                      },
                    }}
                  />
                </div>
              </>
            </Paper>
          </>
        ) : (
          <div className={styles.tableLoading}>
            <CircularProgress />
          </div>
        )}
      </Box>
    </div>
  );
};
export default VerifyStoreLocations;
